import stringHelper from "./stringHelper";

const dateTimeHelper = {
  formatDate: (date) => {
    if (!date) {
      return;
    }
    return (
      date.substring(5, 7) +
      "/" +
      date.substring(8, 10) +
      "/" +
      date.substring(0, 4)
    );
  },

  dLDateToDBDate: (dlDate) => {
    return (
      dlDate.substring(4, 8) +
      "-" +
      dlDate.substring(0, 2) +
      "-" +
      dlDate.substring(2, 4)
    );
  },

  isDBDateOverAge(dbDate, age) {
    const date = new Date(dbDate);
    const dateYear = date.getFullYear();
    const dateMonth = date.getMonth() + 1;
    const dateDay = date.getDate();

    const today = new Date();
    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth() + 1;
    const todayDay = today.getDate();

    const yearDiff = todayYear - dateYear;

    if (yearDiff > age) {
      return true;
    }
    if (yearDiff < age) {
      return false;
    }
    //deal with age
    if (todayMonth > dateMonth) {
      return true;
    }
    if (todayMonth < dateMonth) {
      return false;
    }
    //in the birth month
    if (todayDay >= dateDay) {
      return true;
    }
    return false;
  },

  isDBDate21: (dbDate) => {
    const date = new Date(dbDate);
    const dateYear = date.getFullYear();
    const dateMonth = date.getMonth() + 1;
    const dateDay = date.getDate();

    const today = new Date();
    const todayYear = today.getFullYear();
    const todayMonth = today.getMonth() + 1;
    const todayDay = today.getDate();

    const yearDiff = todayYear - dateYear;

    if (yearDiff > 21) {
      return true;
    }
    if (yearDiff < 21) {
      return false;
    }
    //deal with 21 years
    if (todayMonth > dateMonth) {
      return true;
    }
    if (todayMonth < dateMonth) {
      return false;
    }
    //in the birthmonth
    if (todayDay >= dateDay) {
      return true;
    }
    return false;
  },

  formattedDateToDbDate: (dateStr) => {
    return (
      dateStr.substring(6, 10) +
      "-" +
      dateStr.substring(0, 2) +
      "-" +
      dateStr.substring(3, 5)
    );
  },

  isValidDate: (date) => {
    const checkDate = new Date(date);
    return !(checkDate.toString() === "Invalid Date");
  },

  getTodayAsDBString: () => {
    const today = new Date();
    return dateTimeHelper.dateToDBString(today);
  },

  dateToDBString: (date) => {
    const yearVal = date.getFullYear();
    const monthVal = date.getMonth() + 1;
    const dayVal = date.getDate();
    return (
      "" +
      yearVal +
      "-" +
      (monthVal < 10 ? "0" + monthVal : "" + monthVal) +
      "-" +
      (dayVal < 10 ? "0" + dayVal : "" + dayVal)
    );
  },

  formatTime: (time, military) => {
    const militaryHourVal = parseInt(time.substring(0, 2));
    const minuteVal = parseInt(time.substring(3, 5));

    if (!military) {
      const newHourVal =
        militaryHourVal > 12 ? militaryHourVal - 12 : militaryHourVal;
      const AMPM = militaryHourVal > 12 ? "PM" : "AM";
      return (
        "" +
        newHourVal +
        ":" +
        (minuteVal < 10 ? "0" + minuteVal : "" + minuteVal) +
        " " +
        AMPM
      );
    } else {
      return (
        "" +
        militaryHourVal +
        ":" +
        (minuteVal < 10 ? "0" + minuteVal : "" + minuteVal)
      );
    }
  },

  isValidTime: (timeVal) => {
    if (timeVal.length > 5) {
      return false;
    }
    const colonPos = timeVal.indexOf(":");
    if (colonPos < 1 || colonPos > 2) {
      //reject if if the colon is out of place
      return false;
    }
    const hourStringVal = timeVal.substring(0, timeVal.indexOf(":"));
    const minuteStringVal = timeVal.substring(
      timeVal.indexOf(":") + 1,
      timeVal.length
    );
    if (!stringHelper.isANumber(hourStringVal)) {
      return false;
    }
    if (!stringHelper.isANumber(minuteStringVal)) {
      return false;
    }
    //Right side should never be fewer than two characters
    if (minuteStringVal.length < 2) {
      return false;
    }
    const hourVal = parseInt(hourStringVal);
    const minuteVal = parseInt(minuteStringVal);
    //invald number ranges
    if (hourVal < 0 || hourVal > 24) {
      return false;
    } else {
      if (minuteVal < 0 || minuteVal > 60) {
        return false;
      }
    }
    return true;
  },
  getDayOfWeek: (date) => {
    switch (date.getDay()) {
      case 0:
        return "Sunday";
      case 1:
        return "Monday";
      case 2:
        return "Tuesday";
      case 3:
        return "Wednesday";
      case 4:
        return "Thursday";
      case 5:
        return "Friday";
      case 6:
        return "Saturday";
    }
  },

  windowDate: (dateValue) => {
    const date = new Date(dateValue);
    return (
      dateTimeHelper.getDayOfWeek(date) +
      ", " +
      (date.getMonth() + 1) +
      "/" +
      date.getDate() +
      ", " +
      (date.getHours() > 12 ? date.getHours() - 12 : date.getHours()) +
      ":" +
      date.getMinutes() +
      (date.getHours() > 12 ? "pm" : "am")
    );
  },
};
export default dateTimeHelper;
